/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_RemovedInputs */

const vi_camera_location_removed = /** @type {(inputs: Camera_Location_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gỡ camera khỏi vùng trồng`)
};

/**

* @param {Camera_Location_RemovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_removed = /** @type {((inputs?: Camera_Location_RemovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_RemovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_removed(inputs)
});